const mock = {
  value: '<p>This is text in a paragraph tag</p>',
};

export default mock;
